module.exports = __webpack_public_path__ + "static/media/amana-logo.d0aa5581.png";